<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="ticketModal" tabindex="-1" role="dialog" aria-labelledby="ticketModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="notesModalHeader">
              Create Ticket for Domain: <span class="text-primary">{{ domainDetails.domain }}</span>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="loading" class="loader"></div>
            <section v-else>
              <section v-if="storageTickets.length > 0">
                <h6 class="mb-5">Recent Storage Tickets History</h6>
                <div v-for="(row, index) in topStorageTickets" :key="index" class="row mt-2">
                  <div class="col-md-12">{{ formatDate(row.createdAt) }}  <b>- </b>  <a :href="`https://portal.bigscoots.com/admin/?cmd=tickets&action=view&brc=MTA&list=requirescustomerupdate&num=${row.ticketId}`" target="_blank">{{row.ticketId}}</a> <b v-if="row.ticketTitle"> -</b> {{row.ticketTitle || ''}}  <b> -</b>
                    <small><span class="fs-10 badge mr-2 ml-5" :class="{'badge-primary':(row.ticketStatus === 'Open'),'badge-default':(row.ticketStatus ===  'Closed'), 'badge-danger':(row.ticketStatus ===  'Client-Reply'), 'badge-success': (row.ticketStatus ===  'Answered'),'badge-info': (row.ticketStatus ===  'In-Progress'), 'badge-warning': row.status === 'Pending Client'}">{{ row.status }}</span></small>
                    <b> -</b>  by <b>{{ row.createdBy }}</b></div>
                </div>
                <hr>
              </section>
              <section v-if="monitorTickets.length > 0">
                <h6 class="mb-5">Recent Domain Expiry Incident History</h6>
                <div v-for="(row, index) in monitorTickets" :key="index" class="row mt-2">
                  <div class="col-md-12">{{ formatDate(row.createdAt) }}  <b>- </b>  <a :href="`https://portal.bigscoots.com/admin/?cmd=tickets&action=view&brc=MTA&list=requirescustomerupdate&num=${row.ticketId}`" target="_blank">{{row.ticketId}}</a> <b v-if="row.ticketTitle"> -</b> {{row.ticketTitle || ''}}  <b> -</b>
                    <small><span class="fs-10 badge mr-2 ml-5" :class="{'badge-primary':(row.status === 'Open'),'badge-default':(row.status ===  'Closed'), 'badge-danger':(row.status ===  'Client-Reply'), 'badge-success': (row.status ===  'Answered'),'badge-info': (row.status ===  'In-Progress'), 'badge-warning': row.status === 'Pending Client'}">{{ row.status }}</span></small>
                    <b> -</b>  by <b>{{ row.addedBy }}</b></div>
                </div>
                <hr>
              </section>
              <section>
                <form @submit.prevent="submit">
                  <div class="row">
                    <div class="col-md-12">
                      <label>Domain:</label>
                      <input type="text" v-model="domainDetails.domain" disabled name="subject" class="form-control" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label>Subject:</label>
                      <input type="text" v-model="subject" name="subject" class="form-control" />
                    </div>
                  </div>
                  <section >
                    <div class="row mt-3" >
                      <div class="col-md-6">
                        <label>Message:</label>
                        <textarea class="form-control" rows="8" v-model="ticketMessage"></textarea>
                      </div>
                      <div class="col-md-6">
                        <label>Presets:</label>
                        <ul class="list-unstyled preset">
                          <li v-for="(macro, index) of presetMacros" :key="index" @click="useThisMacro(macro)">
                            <h6><span v-html="(macro.title)? macro.title : ''"></span></h6>
                            <span v-html="(macro.message) ? macro.message.split('\n')[0].substr(0,40).replace(/\n/g,'<br>') + '...' : macro.split('\n')[0].substr(0,40).replace(/\n/g,'<br>')"></span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <label>Select Status:</label>
                        <select class="form-control" v-model="ticketStatus">
                          <option value="Open">Open</option>
                          <option value="Closed">Closed</option>
                          <option value="Client-Reply">Client-Reply</option>
                          <option value="In-Progress">In-Progress</option>
                          <option value="Answered">Answered</option>
                          <option value="Pending Client">Pending Client</option>
                        </select>
                      </div>
                      <div class="col-md-6">
                        <label>Select Priority:</label>
                        <select class="form-control" v-model="ticketPriority">
                          <option value="High">High</option>
                          <option value="Low">Low</option>
                          <option value="Medium">Medium</option>
                        </select>
                      </div>
                    </div>

                    <!--                    <div class="row">-->
                    <!--                      <div class="col-md-12" v-if="action !== 'Leave in migration'">-->
                    <!--                        <div class="custom-control custom-checkbox pull-left mt-3 ml-3 mr-sm-2">-->
                    <!--                          <input type="checkbox" v-model="sendTicketReply" name="action" class="custom-control-input" id="ticket-reply" />-->
                    <!--                          <label class="custom-control-label pt-1" for="ticket-reply">Send ticket reply</label>-->
                    <!--                        </div>-->
                    <!--                      </div>-->
                    <!--                    </div>-->
                  </section>
                  <!--                  <div class="row mt-3" >-->
                  <!--                    <div class="col-md-12">-->
                  <!--                      <span class="text-danger">Ticket ID is not associated with this migration.</span>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
<!--                  subm-->
                  <div class="row">
                    <div class="col-md-12">
                      <button class="btn btn-sm btn-primary pull-right" type="submit" :disabled="loading">Submit</button>
                    </div>
                  </div>
                </form>
              </section>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {db} from "@/firebase/init";
import swal from "sweetalert2";

export default {
  name: "ticketModal",
  data(){
    return {
      ticketMessage: null,
      ticketStatus: 'Answered',
      ticketPriority: 'Low',
      subject: '',
      type: null,
      loading: false,
      sendTicketReply: false,
      index: null,
      action: 'Leave in migration',
      requiredTasks: [],
      presetMacros: [],
      domainDetail: {},
      tickets: [],
      assignTicketUrl: false,
      domainDetails: {},
      storageTickets: [],
      monitorTickets: []
    }
  },
  mounted() {
    // this.getMonitorTickets()
  },
  computed: {
    topStorageTickets() {
      return this.storageTickets.sort((a,b)=> new Date(b.createdAt) - new Date (a.createdAt)).slice(0,5);
    },
    user () {
      return this.$store.getters.user;
    },
    docID() {
      return this.$store.getters["customer/docID"];
    },
  },
  methods: {
    async getStorageTickets() {
      try {
        this.loading = true
        this.storageTickets = []
        const ref = await db.collection('storageTickets').doc(this.domainDetails.serverIP).get();
        if (ref.exists) {
          this.storageTickets = ref.data().tickets;
          this.storageTickets = this.storageTickets.sort((a,b)=> new Date(b.createdAt) - new Date (a.createdAt)).slice(0,5);
          const response = await this.$http.post('/host-bill/fetch-bulk-ticket-details', {
            grant_type: 'token',
            ticketData: this.storageTickets
          });
          console.log('response', response.data)
          this.storageTickets = response.data.ticketData
        }
        if(this.domainDetails.monitorId) {
          const monitorTickets = await db.collection('monitorTickets').doc(this.domainDetails.monitorId).get();
          if(monitorTickets.exists) {
            const { tickets } = monitorTickets.data();
            if(tickets.length) {
              this.monitorTickets = tickets.filter(el=> el.type === 'domainExpiry').sort((a,b)=> new Date(b.createdAt) - new Date (a.createdAt)).slice(0,5);
            }
          }
        }
      } catch (e) {
        console.log('no ticket found', e.toString())
      } finally {
        this.loading = false;
      }
    },
    formatDate(date){
      return moment(date).local().fromNow()
    },
    async useThisMacro (macro) {
      this.loading = true
      let msg = (macro.message) ? macro.message : macro;
      const userRef = await db.collection('users').doc(this.docID).get()
      const user = userRef.data()
      msg = msg.replace(/{firstName}/g, user.firstName)
      msg = msg.replace(/{lastName}/g, user.lastName)
      msg = msg.replace(/{domain}/g, this.domainDetails.domain)
      msg = msg.replace(/{email}/g, user.email)
      msg = msg.replace(/{signature}/g, this.user.signature)
      if (msg.includes('{ipaddress}') || msg.includes('{maxStorage}') || msg.includes('{currentStorage}')) {
        const accountRef = await db.collection('hostingAccounts').doc(this.docID).get()
        const { accounts } = accountRef.data()
        let selectedAccount = null
        let selectedPlan = null
        for (const account of accounts) {
          if (account.primary.domain === this.domainDetails.domain) {
            selectedAccount = account.primary;
            selectedPlan = account;
          }
          for (const addon of account.addon) {
            if (addon.domain === this.domainDetails.domain) {
              selectedAccount = addon;
              selectedPlan = account;
            }
          }
        }
        if (selectedAccount) {
          const ip = selectedAccount.serverIP || 'N/A'
          msg = msg.replace(/{ipaddress}/g, ip )
        }
        if (selectedPlan) {
          // parse max storage
          if (msg.includes('{maxStorage}')) {
            const maxStorageSize = selectedPlan.maxStorageSize ? selectedPlan.maxStorageSize + ' GB' : 'N/A';
            msg = msg.replace(/{maxStorage}/g, maxStorageSize )
          }
          if (msg.includes('{currentStorage}')) {
            if(selectedPlan.fullDiskSpace && selectedPlan.fullDiskSpace.totalUsageObj && typeof selectedPlan.fullDiskSpace.totalUsageObj === 'string'){
              const currentStorage = (selectedPlan.fullDiskSpace.totalUsageObj !== 'undefined')
                  ? `${selectedPlan.fullDiskSpace.totalUsageObj}`: 0;
              msg = msg.replace(/{currentStorage}/g, currentStorage )
            }
            else{
              // parse current storage
              const currentStorage = (selectedPlan.fullDiskSpace && typeof selectedPlan.fullDiskSpace[2] !== 'undefined')
                  ? `${selectedPlan.fullDiskSpace[2].size} ${selectedPlan.fullDiskSpace[2].value}B`: 0;
              msg = msg.replace(/{currentStorage}/g, currentStorage )
            }

          }
        }
      }
      this.ticketMessage = msg;
      this.ticketStatus = (macro.status) ? macro.status : 'Answered';
      this.ticketPriority = (macro.priority) ? macro.priority : 'Low';
      this.subject= macro.title ? macro.title.replace(/{domain}/g, this.domainDetails.domain) : ''
      this.loading = false
    },
    async load (presets, domainDetails) {
      this.domainDetails = domainDetails
      console.log('domain details', this.domainDetails)
      this.presetMacros=presets
      $('#ticketModal').modal('show');
      await this.getStorageTickets()
    },
    async submit () {
      try {
        this.loading = true
        let accountRef = await db.collection('users').doc(this.docID).get();
        accountRef = accountRef.data();
        let response=await this.$http.post('host-bill/open-new-ticket', {
          grant_type: 'token',
          message: this.ticketMessage,
          priority: this.ticketPriority,
          clientID: accountRef.customerID,
          subject: this.subject,
          status: this.ticketStatus,
          domain: this.domainDetails.domain,
          name: this.user.firstName + ' ' + this.user.lastName,
          email: accountRef.email
        })
        console.log('response', response)
        try {
          if(this.subject === 'Storage Overage') {
            const obj = {
              domain: this.domainDetails.domain,
              ticketTitle: this.subject,
              ticketId: response.data.ticket_id,
              ticketStatus: this.ticketStatus,
              createdBy: this.user.firstName + ' ' + this.user.lastName,
              createdAt: new Date().toISOString(),
              uid: this.docID
            }
            const ref = await db.collection('storageTickets').doc(this.domainDetails.serverIP).get();
            if(ref.exists) {
              const { tickets } = ref.data();
              tickets.push(obj)
              await db.collection('storageTickets').doc(this.domainDetails.serverIP).update({
                tickets
              })
            } else {
              await db.collection('storageTickets').doc(this.domainDetails.serverIP).set({tickets: [obj]})
            }
          }
        } catch (e) {
          console.log('error while saving storage tickets',e.toString())
        }
        await swal({
          title: "Success",
          text: 'Ticket has been created successfully',
          type: "success"
        })
        window.open(`https://portal.bigscoots.com/admin/?cmd=tickets&action=view&brc=MTA&list=requirescustomerupdate&num=${response.data.ticket_id}`, '_blank')
      } catch (e) {
        this.loading = false
        swal({
          title: "Error",
          text: e.toString(),
          type: "error"
        })
      }finally
      {
        this.loading = false
        this.ticketMessage=''
        this.subject=''
        $('#ticketModal').modal('hide');

      }
    },
  }
}
</script>

<style lang="scss" scoped>
.preset {
  height: 230px;
  overflow: auto;
  li {
    cursor: pointer;
    border: 1px solid rgba(0,0,0,0.3);
    padding: 2px;
    background-color: rgba(0,0,0,0.1);
    border-radius: 3px;
    margin: 2px 0;
  }
}
</style>
